if ((typeof MThemes) === 'undefined') {
  MThemes = {};
}

MThemes.initQS = function(selector){
  $(selector).click(function(){
  	var handle = $(this).attr('data-handle');
    Shopify.getProduct(handle);
    Shopify.onProduct = function(product) {
    	console.log(product);
    }
  });
}

$(document).ready(function(){
	MThemes.initQS('.quick_shop.btn');
});